import { render, staticRenderFns } from "./SEUDashboards.vue?vue&type=template&id=63ba6022&"
import script from "./SEUDashboards.vue?vue&type=script&lang=js&"
export * from "./SEUDashboards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports